import { render, staticRenderFns } from "./PaymentTariffRuleList.vue?vue&type=template&id=3f06b8cd&lang=pug"
import script from "./PaymentTariffRuleList.vue?vue&type=script&lang=js"
export * from "./PaymentTariffRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports